import { Box } from '@mui/material';
import { ReactNode } from 'react';

import { useSxStyles } from './useStyles';

type Props = {
  label: string;
  value?: string;
  children?: ReactNode | JSX.Element;
  variant?: 'row' | 'stacked';
};

export const LegacyFieldReadMode = (props: Props) => {
  const sxStyles = useSxStyles();
  const { label, value, variant, children } = props;

  return (
    <Box sx={sxStyles.root} className={variant}>
      <Box sx={sxStyles.label}>{label}</Box>
      <Box sx={sxStyles.value}>{!!value ? value : children}</Box>
    </Box>
  );
};
